import BaseRequest from "@common/services/_baseRequest";


export default {

	list: ( id_accreditamento, cb, ecb = null) => {
		var req = new BaseRequest();
		req.makeRequest(
			{},
			{},
			null,
			"get",
			'accreditamento/scheda/dati-identificativi/' + id_accreditamento,
			cb,
			ecb || null,
			null
		);
	},

	save: ( id_accreditamento, data, cb, ecb = null) => {
		var req = new BaseRequest();
		req.makeRequest(
			{},
			data,
			null,
			"post",
			'accreditamento/scheda/dati-identificativi/' + id_accreditamento,
			cb,
			ecb || null,
			null
		);
	},

	saveEnteManuale: ( data, cb, ecb = null) => {
		var req = new BaseRequest();
		req.makeRequest(
			{},
			data,
			null,
			"post",
			'accreditamento/inserimento-ente-manuale',
			cb,
			ecb || null,
			null
		);
	},


}
